import { NgModule } from '@angular/core'

import { AdvancedTableModule } from './advanced-table'
import { DateFieldModule } from './date-selector'
import { MaintenanceBannerModule } from './maintenance-banner'
import { PageTitleModule } from './page-title'
import { PhoneFieldModule } from './phone-field'
import { ProgressModule } from './progress'

@NgModule({
  imports: [
    ProgressModule,
    AdvancedTableModule,
    DateFieldModule,
    MaintenanceBannerModule,
    PageTitleModule,
    PhoneFieldModule,
  ],
  exports: [
    ProgressModule,
    AdvancedTableModule,
    DateFieldModule,
    MaintenanceBannerModule,
    PageTitleModule,
    PhoneFieldModule,
  ],
})
export class SharedComponentsTestingModule {}
